import React, { Component } from 'react';
import _ from 'lodash';
import { FontIcon, Button } from 'react-md';
import './TableActionBar.scss';
import { FilterChip, FilterBar, SearchInput } from '../index';
import { createFilterList } from '../../utils';
import { connect } from 'react-redux';
import { applyOrgFilter, applyPeopleFilter, applyLotFilter, applySearch, setSearchTerm, clearSearchTerm } from '../../actions/filter.action';
import Fuse from 'fuse.js';
import { getOrganizations } from '../../actions/organizations.action';
import { FUSE_OPTIONS } from '../../utils';
class TableActionBar extends Component {
  state = {
    activeFilter: false
  }

  componentDidMount() {
    if (!this.props.organizations || (this.props.organizations.length < 1 && this.props.title !== 'Organizations')) {
      this.props.getOrganizations();
    }
  }
  // compares input object propertie(s)
  // if the match is exact, setOrgs will be set for checkbox selection
  compareLotOrgs = (data) => {
    let matchingLots = [];
    if (data.length > 0) {
      const lotPartyKeysArray = data[0].organizations.map(org => org.partyKey);
      const lotPartyKeys = data.map(lot => {
        return lot.organizations.map(org => {
          return org.partyKey;
        });
      });

      const comparison = (lotPartyKeys.map(v => _.isEqual(v.sort(), lotPartyKeysArray.sort()) ? true : false ));
      matchingLots = comparison.every(val => val === true) ? data[0].organizations : [];
    }
    this.props.setOrgs(matchingLots, matchingLots.length < 1 ? false : true);
  }

  applyFilter = (filterArr) => {
    const { title, applyOrgFilter, applyPeopleFilter, applyLotFilter, rels, people, lots } = this.props;
    const filteredOrgData = [];
    const filteredPeopleData = [];
    const filteredLotData = [];
    this.setState({ activeFilter: true });
    if (title === 'Organizations') {
      rels.forEach(x => {
        if (filterArr.includes(x.parentKey)) {
          filteredOrgData.push(x);
        } else if (filterArr.includes(x.childFrom)) {
          filteredOrgData.push(x);
        } else if (filterArr.includes(x.childKey)) {
          filteredOrgData.push(x);
        }
      });

      return applyOrgFilter(filteredOrgData);
    } else if (title === 'People') {
      people.forEach(x => {
        if (x.relationships && x.relationships.some(r => filterArr.includes(r.fromPartyKey))) {
          filteredPeopleData.push(x);
        }
      });

      return applyPeopleFilter(filteredPeopleData);
    } else if (title === 'Lots/Garages') {

      lots.forEach(x => {
        if (x.organizations.some(r => filterArr.includes(r.partyKey))) {
          filteredLotData.push(x);
        }
      });


      if (filteredLotData.length > 0) {
        this.compareLotOrgs(filteredLotData);
      }

      return applyLotFilter(filteredLotData);
    }
  }

  removeFilter = () => {
    const { title, applyOrgFilter, applyPeopleFilter, applyLotFilter } = this.props;
    if (title === 'Organizations') {
      applyOrgFilter(null);
    } else if (title === 'People') {
      applyPeopleFilter(null);
    } else if (title === 'Lots/Garages') {
      applyLotFilter(null);
    }
  }


  handleSearch = (term) => {
    const { applySearch, people, lots, title, rels } = this.props;
    const searchList = title === 'People' ? people : title === 'Organizations' ? rels : lots;
    const fuse = new Fuse(searchList, FUSE_OPTIONS);
    const results = fuse.search(term);
    if (title === 'Lots/Garages' && results.length) {
      this.compareLotOrgs(results);
    }
    applySearch(results, term);
  }

  render() {
    const { title, show, clients, teams } = this.props;
    const filterDataClients = clients.map(x => { return { id: x.childKey, name: x.childName }; });
    const filterDataTeams = teams.map(x => { return { id: x.childKey, name: x.childName }; });

    return (
      <div className="table-action-bar">
        <FilterBar>
          {
            title !== 'Lots/Garages' &&
            <FilterChip
              data={createFilterList(filterDataClients, 'name')}
              filterKey="lotIdFilter"
              id={`${title.toLowerCase()}-client-filter`}
              label="Clients"
              onApply={this.applyFilter}
              onRemove={this.removeFilter}
              activeFilter={this.state.activeFilter}
            />
          }
          <FilterChip
            data={createFilterList(filterDataTeams, 'name')}
            filterKey="lotIdFilter"
            id={`${title.toLowerCase()}-client-filter`}
            label="Teams"
            onApply={this.applyFilter}
            onRemove={this.removeFilter}
            activeFilter={this.state.activeFilter}
          />
          <SearchInput
            id={`${title.toLowerCase()}-client-filter`}
            handleSearch={this.handleSearch}
            setSearchTerm={this.props.setSearchTerm}
            clearSearchTerm={this.props.clearSearchTerm}
            searchTerm={this.props.searchTerm}
          />
        </FilterBar>
        <div className="add-item-container">
          {
            title !== 'Lots/Garages' &&
            <Button
              id={`${title.toLowerCase()}-open-wizard`}
              className="add-item-button"
              flat
              onClick={() => {
                this.props.resetSort();
                this.removeFilter();
                this.setState({ activeFilter: false });
                show({ title });
              }}
            >
              <FontIcon key="group_add">group_add</FontIcon>
              <div className="add-item-button-label">
                {
                  title === 'People' ? 'create user' :
                    title === 'Organizations' ? 'create organization' :
                      title === 'Lots/Garages' && 'create Lot/Garage'
                }
              </div>
            </Button>
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  organizations: state.organizations.data,
  rels: state.organizations.relationships,
  clients: state.organizations.clients,
  teams: state.organizations.teams,
  people: state.users.data,
  lots: state.lots.data,
  searchTerm: state.filter.searchTerm
});

export default connect(mapStateToProps, {
  getOrganizations,
  applyOrgFilter,
  applyPeopleFilter,
  applyLotFilter,
  applySearch,
  setSearchTerm,
  clearSearchTerm
})(TableActionBar);



// WEBPACK FOOTER //
// ./src/components/TableActionBar/TableActionBar.jsx